import cObject from './cObject';


var dhtmlXTreeItemObject = (function () {
    function dhtmlXTreeItemObject(l, c, e, a, g, h) {
        this.htmlNode = "";
        this.acolor = "";
        this.scolor = "";
        this.tr = 0;
        this.childsCount = 0;
        this.tempDOMM = 0;
        this.tempDOMU = 0;
        this.dragSpan = 0;
        this.dragMove = 0;
        this.span = 0;
        this.closeble = 1;
        this.childNodes = new Array();
        this.userData = new cObject();
        this.checkstate = 0;
        this.treeNod = a;
        this.label = c;
        this.parentObject = e;
        this.actionHandler = g;
        this.images = new Array(a.imageArray[0], a.imageArray[1], a.imageArray[2]);
        this.id = a._globalIdStorageAdd(l, this);
        if (this.treeNod.checkBoxOff) {
            this.htmlNode = this.treeNod._createItem(1, this, h);
        }
        else {
            this.htmlNode = this.treeNod._createItem(0, this, h);
        }
        this.htmlNode.objBelong = this;
        return this;
    }
    return dhtmlXTreeItemObject;
})();

export default dhtmlXTreeItemObject;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeObject/dhtmlXTreeItemObject.js